import {Component, Input, OnInit} from '@angular/core';
import {FormGroup, Validators} from "@angular/forms";
import {RestService} from "../shared/rest/rest.service";

@Component({
  selector: 'app-domain-select',
  templateUrl: './domain-select.component.html',
  styleUrls: ['./domain-select.component.scss']
})
export class DomainSelectComponent implements OnInit {

  domainNames = [];

  constructor(protected restService: RestService) { }

  @Input()
  set group(value: FormGroup) {
    this._group = value;
  }

  @Input()
  required: boolean = true;

  _group: FormGroup

  @Input()
  controlName: string;

  @Input()
  labelKey: string;

  ngOnInit(): void {
    this.restService.getDomainNames()
      .subscribe(dN => this.domainNames = dN);
    if(this.required && this.domainNames.length > 1) {
      this._group.controls[this.controlName]?.setValidators([Validators.required]);
    }
  }

}
